import logo from "../company logo.jpeg"; // adjust path as needed

function MyFooter() {
    return (
        <footer
            className="footer py-2"
            style={{
                position: "fixed",
                bottom: 0,
                left: 0,
                width: "100%",
                zIndex: 1000,
                backgroundColor: "#e3f2fd", // light blue background
                borderTop: "1px solid #ddd",
            }}
        >
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-sm-6">
                        <div className="text-muted">
                            {/* Left side empty */}
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="text-sm-end d-none d-sm-block">
                            <a
                                href="https://websmart.org.in/"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    color: "black",
                                    textDecoration: "none",
                                    fontWeight: "bold",
                                    display: "inline-flex",
                                    alignItems: "center",
                                }}
                            >
                                <img
                                    src={logo}
                                    alt="Company Logo"
                                    style={{ height: "40px", marginRight: "10px" }}
                                />
                                Web Smart Technology
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default MyFooter;
